import { queryOptions, skipToken } from '@tanstack/react-query';

import { fetchLogbookConfigurationDetails } from './listApi';

export const logbookConfigurationKeys = {
    all: ['logbookConfiguration'] as const,
    detail: (logbookAssetConfigurationId: string) => [...logbookConfigurationKeys.all, logbookAssetConfigurationId] as const,
};

export const logbookConfigurationQueryOptions = (logbookAssetConfigurationId: string | undefined) =>
    queryOptions({
        queryKey: logbookConfigurationKeys.detail(logbookAssetConfigurationId ?? ''),
        queryFn: logbookAssetConfigurationId
            ? ({ signal }) => fetchLogbookConfigurationDetails(logbookAssetConfigurationId, signal)
            : skipToken,
        staleTime: Infinity,
    });
